import { render } from "./ProducerDashboard.vue?vue&type=template&id=0a08de51"
import script from "./ProducerDashboard.vue?vue&type=script&lang=js"
export * from "./ProducerDashboard.vue?vue&type=script&lang=js"

import "./ProducerDashboard.vue?vue&type=style&index=0&id=0a08de51&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__